import { Package, Truck, Database, FileSpreadsheet, Workflow } from 'lucide-react';

export const AddOnsGrid = () => {
  const integrations = [
    {
      name: 'Sysco Integration',
      icon: Truck,
      description: 'Generate CSV purchase orders automatically and sync with Sysco\'s ordering system',
      highlighted: true,
    },
    {
      name: 'Google Sheets Export',
      icon: FileSpreadsheet,
      description: 'Export inventory reports and menus to share with camp leadership or board members',
    },
    {
      name: 'Supabase Analytics',
      icon: Database,
      description: 'Track food costs, waste metrics, and kitchen performance over time',
    },
    {
      name: 'Toast POS / Square POS',
      icon: Package,
      description: 'Sync menu items with point-of-sale systems for camp stores or snack bars',
    },
    {
      name: 'n8n Automation Tools',
      icon: Workflow,
      description: 'Build custom workflows for ordering, inventory alerts, and team notifications',
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-muted/30 to-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">Camp Kitchen Integrations</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Connect CampChef Pro with the tools you already use to run your camp
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {integrations.map((integration, index) => {
            const Icon = integration.icon;
            return (
              <div
                key={integration.name}
                className={`group relative bg-card/80 backdrop-blur-sm border rounded-xl p-6 hover:shadow-lg hover:border-copper/40 transition-all duration-300 animate-fade-in ${
                  integration.highlighted 
                    ? 'border-copper border-2 bg-copper/5' 
                    : 'border-border'
                }`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {integration.highlighted && (
                  <div className="absolute -top-3 left-4 bg-copper text-white text-xs font-semibold px-3 py-1 rounded-full">
                    Featured
                  </div>
                )}
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-lg bg-gradient-to-br from-copper/10 to-copper/5 group-hover:from-copper/20 group-hover:to-copper/10 transition-colors">
                    <Icon className="h-6 w-6 text-copper" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      {integration.name}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {integration.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <p className="text-sm text-muted-foreground">
            Looking for something specific? <span className="text-copper font-medium">Enterprise plans</span> include custom integrations and dedicated setup support.
          </p>
        </div>
      </div>
    </section>
  );
};
